import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { QRInput } from 'src/app/models/qr-input.model';

@Component({
  selector: 'app-dialog-limpiar-cuenta-corriente',
  templateUrl: './dialog-limpiar-cuenta-corriente.component.html',
  styleUrls: ['./dialog-limpiar-cuenta-corriente.component.scss'],
})
export class DialogLimpiarCuentaCorriente implements OnInit {
  value: any;
  @Output() onChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  inputString: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Nombre',
  };

  ngOnInit(): void {
    this.onChange.emit(true);
  }
}
